import React, { Component } from 'react'
import ColorInput from 'components/ColorInput'
import style from './style.styl'
import cx from 'classnames'
import InlineSVG from 'svg-inline-react'
import { ToolTip, Button } from '@driftt/tide-core-legacy'

const ICON_SRC = require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/icons/info-icon.svg')

const VALID_COLOR_REGEX = /^[a-fA-F0-9]{6}$/

const isValidColor = function(hex) {
  return VALID_COLOR_REGEX.test(hex)
}


const makeTitle = (titleText, toolTipComponent) => (
  <div className="color-input-title">
    <div>{titleText}</div>
    <div>
      <ToolTip
        flow="up"
        component={toolTipComponent}
      >
        <InlineSVG className="icon-image" src={ICON_SRC} />
      </ToolTip>
    </div>
  </div>
)


export default class ColorPicker extends Component {


  isValidScheme = () => {
    const {
      backgroundColor,
      foregroundColor,
      activeColor,
      textColor,
      widgetBackgroundColor
    } = this.props.colors
    return !Object.keys(this.props.colors).some(key => !isValidColor(this.props.colors[key]))
    && backgroundColor.toLowerCase() !== foregroundColor.toLowerCase()
    && backgroundColor.toLowerCase() !== textColor.toLowerCase()
    && activeColor.toLowerCase() !== 'ffffff'
  }

  render() {
    const {
      backgroundColor,
      foregroundColor,
      activeColor,
      textColor,
      widgetBackgroundColor,
    } = this.props.colors
    return(
      <div className={cx('flex-column', style.ColorPicker)}>
        <div className="flex-column" style={{paddingBottom: this.props.hasChanged() ? 0 : 24}}>
          <ColorInput
            label={
              makeTitle(
                "Primary Color",
                <div className="tooltip-text">
                  Background color for widget header and <br/>
                  visitor message bubbles, embedded button<br/>
                  colors, text and border color for button<br/>
                  responses, and background color of chat<br/>
                  button when widget is closed.
                </div>
            )}
            valid={isValidColor(backgroundColor)}
            color={backgroundColor}
            size="medium"
            onChange={(hex) => this.props.onChange("backgroundColor", hex)}
            className="color-input"
          />
          <div className="color-input-description">
            Use a dark brand color that&rsquo;s recognizable and stands out on your website
          </div>
          <ColorInput
            label={
              makeTitle(
                "Secondary Color",
                <div className="tooltip-text">
                  Foreground color for text/icons in widget<br/>
                  header and visitor message bubbles, text in<br/>
                  embedded buttons, background color for<br/>
                  button responses, and icon of chat button<br/>
                  when widget is closed.
                </div>
            )}
            valid={isValidColor(foregroundColor)}
            color={foregroundColor}
            size="medium"
            onChange={(hex) => this.props.onChange("foregroundColor", hex)}
            className="color-input"
          />
          {foregroundColor.toLowerCase() === backgroundColor.toLowerCase() && <div className="color-input-error">Cannot be same as Primary Color</div>}
          <div className="color-input-description">
            Use a lighter color that will be legible on the Primary Color
          </div>
          <ColorInput
            label={
              makeTitle(
                "Send Button Color",
                <div className="tooltip-text">
                  Color for text and icon of the Send<br/>
                  button that appears when visitor has<br/>
                  entered text into the Drift widget.
                </div>
              )}
            valid={isValidColor(activeColor)}
            color={activeColor}
            size="medium"
            onChange={(hex) => this.props.onChange("activeColor", hex)}
            className="color-input"
          />
          <div className="color-input-description">Use a strong color with a clear call to action</div>
          {activeColor.toLowerCase() === 'ffffff' && (
            <span className="hyperlink-color-error">
              Sorry, this color can’t be white because buttons and links will disappear!
            </span>
          )}
          <ColorInput
            label={
              makeTitle(
                "Chat Text Color",
                <div className="tooltip-text">Text color for visitor messages</div>
            )}
            valid={isValidColor(textColor)}
            color={textColor}
            size="medium"
            onChange={(hex) => this.props.onChange("textColor", hex)}
            className="color-input"
          />
          {textColor.toLowerCase() === backgroundColor.toLowerCase() && <div className="color-input-error">Cannot be same as Primary Color</div>}
          <div className="color-input-description">Use a light color similar to the Secondary Color</div>
          <ColorInput
            label={
              makeTitle(
                "Widget Background Color",
                <div className="tooltip-text">
                  Background color for the<br/>
                  main widget container.
                </div>
            )}
            valid={isValidColor(widgetBackgroundColor)}
            color={widgetBackgroundColor}
            size="medium"
            onChange={(hex) => this.props.onChange("widgetBackgroundColor", hex)}
            className="color-input"
          />
          <div className="color-input-description">Use a very light color for good contrast</div>
          {this.props.hasChanged() &&
            <div className="save-buttons-container">
              <Button onClick={this.props.onSubmit} type="primary" disabled={!this.isValidScheme()}>Save</Button>
              <Button onClick={this.props.onCancel} type="tertiary">Cancel</Button>
            </div>
          }
        </div>
        <div className="color-gray-dark dsg-Regular applies-to-info">
          These colors apply to Campaigns, Emails, Chat and Icons. See more{' '}
          <a href="http://docs.drift.com/articles/customizing-your-colors/" target="_blank">
            details here
          </a>
          .
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/Styling/ColorPicker/index.js